import { AfterViewInit, Component, ElementRef, Input, ViewChild } from '@angular/core';

export interface Header {
  headerText: string,
  path: string,
  fragment?: string
}

@Component({
  selector: 'app-horizontal-menu',
  templateUrl: './horizontal-menu.component.html',
  styleUrls: ['./horizontal-menu.component.scss']
})
export class HorizontalMenuComponent implements AfterViewInit {
  @ViewChild('menu') menu: ElementRef | undefined;
  @Input() headers: Header[] = [];
  @Input() backgroundColor = '#00607e';
  @Input() textColor = '#FFF';
  @Input() alignment = 'left';
  @Input() menuHeight = '6rem';
  @Input() fragment = false;

  ngAfterViewInit(): void {
    if (this.menu?.nativeElement) {
      this.menu.nativeElement.style.justifyContent = this.alignment;
    }
  }
}
